import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export interface VentaCortesiaTipoRow {
  folio_ticket: string;
  venta_id: number;
  fecha_hora_venta: string;
  producto: string;
  tipo: string;
  cantidad: number;
  precio_unitario: number;
  total_venta: number;
  forma_pago: string;
  punto_venta: string;
  transferido: number;
}

export async function getReporteVentasCortesiasTipo(ids_dia: number[]): Promise<VentaCortesiaTipoRow[]> {
  try {
    const response = await axios.get(`${API_URL}cortesias/reporte-ventas-cortesias-tipo`, {
      params: { ids_dia: ids_dia.join(',') },
    });
    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error al obtener el reporte de ventas con cortesías por tipo:', error);
    throw error;
  }
}
